import { Injectable } from "@angular/core";
import { MatSidenav } from "@angular/material/sidenav";

@Injectable()
export class SharedService {
  public header:any={};
  public footer:any={};
  public sideNav:MatSidenav;
}
